<template>
  <div class="container_MerchantInfo">
    <!-- <h1>Template</h1> -->
    <section v-if="info" class="info">
      <h1 class="title">商家信息</h1>
      <div>
        <ul>
          <div class="userImg" style="width: 100%; height: 100%; margin: 0; padding: 25px;">
            <!-- <canvas id="customer"></canvas> -->
            <img style="width: 100%; height: 100%;" :src="addUrlF(userImg)" alt />
          </div>
          <li v-if="member_data.mobile">电话: {{ member_data.mobile }}</li>
          <li v-if="member_data.qq">QQ: {{ member_data.qq }}</li>
        </ul>
      </div>
    </section>
    <section v-if="qrcode" class="qrcode">
      <h1 class="title">手机店铺</h1>
      <div>
        <div class="qrcode_img">
          <canvas id="qrcode"></canvas>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import getData from '@/utils/getData' // 获取数据接口
import { addUrl, getUrlUserInfo } from '../../common/common'
export default {
  data() {
    return {
      timer: null,
      shorturl: null,
      member_data: {},
      addUrlF: addUrl,
      userImg: null
    }
  },
  props: {
    merchantInfo: {
      type: Object,
      required: false
    },
    info: {
      type: Boolean,
      required: false
    },
    qrcode: {
      type: Boolean,
      required: false
    }
  },
  components: {},
  computed: {},
  watch: {},
  methods: {
    // type your function
    getShorturl() {
      return this.merchantInfo.shorturl
    },
    setQrcode() {},
    async getCustomerInfo() {
      let name = await getUrlUserInfo(this.$route.fullPath) // sup 或者 mid
      let info = await getData.getCustomer(name, this.$route.query[name])

      this.member_data = info.member_apply_data
      this.userImg = info.apply_data.customer_service
    }
  },
  created() {},
  mounted() {
    this.setQrcode()
    this.getCustomerInfo()
  },
  updated() {},
  destroyed() {},
  filters: {}
}
</script>

<style scoped lang="less">
@import '../../common/Less/index.less';
.container_MerchantInfo {
  width: 146px;
  // margin: 0;
  section {
    width: 146px;
    height: 250px;
    background: @white;
  }
  .info {
    .title {
      display: inline-block;
      background: #e0f2ff;
      width: 146px;
      height: 38px;
      line-height: 38px;
      margin: 0;
      text-indent: 15px;
      color: @black;
      font-weight: 400;
      font-size: @fontSize - 2;
      letter-spacing: @spacing;
    }
    div {
      ul {
        margin: 0;
        // padding: 26px 0 0 19px;
        padding: 0;
        height: 150px;
        width: 100%;
        position: relative;
        .userImg {
          // position: relative;
          // left: 50%;
          // top: 50%;
          // transform: translate(-50%, -50%);
          margin: 0 auto;

          padding: 0;
          margin: 0;
          text-align: center;
          width: 100%;
          height: 100%;
          img {
            margin: 0 auto;
          }
        }
        li {
          list-style: none;
          color: @black;
          opacity: 0.6;
          line-height: 13px;
          font-size: @fontSize - 4;
          margin-bottom: 14px;
          text-align: center;
        }
      }
      // ul li:nth-child(1) {
      //   margin-top: 50px;
      // }
    }
  }
  .qrcode {
    // margin-top: 14px;
    .title {
      display: inline-block;
      background: #e0f2ff;
      width: 146px;
      height: 38px;
      line-height: 38px;
      margin: 0;
      text-indent: 15px;
      color: @black;
      font-weight: 400;
      font-size: @fontSize - 4;
      letter-spacing: @spacing;
    }
    div {
      position: relative;

      height: calc(100% - 38px);
      width: 100%;
      .qrcode_img {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);

        width: 100px;
        height: 100px;
        // background: @black;
        // opacity: 0.1;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Merchant/MerchantInfo.vue